<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
         <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart(exportFeeUrl, '物业交叉结算统计--欠款', {})">欠款导出</el-button>
        </el-form>
      </div>
    </div>
    <div style="height: 500px;" v-loading="axiosLoading" v-if="axiosLoading"></div>
    <div class="chart-container">
      <div class="chart-item chart-item-long"  v-for="i in total">
        <wt-auth class="search-form-btn" :hasAnyPremission="'PROPERTYSTATISTICS_CROSSSETTLEMENT:EXPORT'">
          <el-button class="chart-export" size="small" @click="exportChart(exportUrl, '物业交叉结算统计--'+ resData[i-1].orgName, {id: resData[i-1].orgId})">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas"
          :id="'deliveryChart' + i"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../statisticalAnalysis/mixin.js'
export default {
  name: 'StatisticalAnalysisPoints',
  mixins: [mixin],
  data() {
    return {
      axiosLoading: false,
      form: {
        dataTimeRange: [],
        communityId: '',
        siteId: ''
      },
      communityOptions: [],
      siteOptions: [],
      exportFeeUrl: '/modules/statisticalProperty/propertyStatisticalSettlementImport2', // 欠款导出
      exportUrl: '/modules/statisticalProperty/propertyStatisticalSettlementImport1', // 导出
      total: 0,
      chartEle: [],
      resData: []
    }
  },
  mounted() {
    // const that = this
    // window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    // const that = this
    // window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      for (const item of this.chartEle) {
        if (item) {
          item.dispose()
        }
      }
      this.propertyStatisticalSettlement()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: []
        }
      }
      this.initPage()
    },
    exportChart(url, name, formData) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + url,
        data: Object.assign(this.form, formData),
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 统计
    propertyStatisticalSettlement() {
      this.axiosLoading = true
      this.$api.propertyStatistics.cross.propertyStatisticalSettlement(this.form).then(res => {
        this.axiosLoading = false
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].consumption === 0 || res.data[i].orgId === 999998) {
            res.data.splice(i, 1)
            i--
          }
        }
        this.total = res.data ? res.data.length : 0
        this.resData = res.data
        this.$nextTick(() => {
          for (let i = 1; i <= res.data.length; i++) {
            this.initDeliveryChart(i, res.data[i - 1])
          }
        })
      }).catch(() => {
        this.axiosLoading = false
      })
    },
    initDeliveryChart(i, data) {
      console.log(data)
      this.chartEle[i] = this.$echarts.init(document.getElementById('deliveryChart' + i))
      this.chartEle[i].setOption(this.getOptions(data))

      // const aa = [{
      //       name: '物业公司消耗积分\n10000积分，约等于100元',
      //       category: 0,
      //       // x: 300,
      //       // y: 300,
      //       symbolSize: [200, 100],
      //       itemStyle: {
      //         color: '#fff',
      //         borderColor: '#000',
      //         borderWidth: 3
      //       }
      //     }, {
      //       name: '物业公司消耗积分\n5000积分，约等于50元',
      //       category: 1
      //       // x: 0,
      //       // y: -300
      //     }, {
      //       name: '物业公司消耗积分\n2000积分，约等于20元',
      //       category: 2
      //       // x: 100,
      //       // y: 600
      //     }, {
      //       name: '物业公司消耗积分\n1000积分，约等于10元',
      //       category: 3
      //       // x: 100,
      //       // y: 100
      //     }, {
      //       name: '物业公司消耗积分\n3000积分，约等于300元',
      //       category: 4
      //       // x: 100,
      //       // y: 100
      //     }]
    },
    getOptions(data) {
      // console.log(data)
      const graphData = []
      const links = []
      graphData.push({
        name: data.orgId + '',
        displayName: data.orgName + '消耗积分\n' + data.consumption + '积分, 约等于' + (data.consumption / 100) + '元',
        value: data.consumption,
        // category: 0,
        symbolSize: [300, 150],
        itemStyle: { borderWidth: 3 },
        label: { normal: { color: '#0a57a6', fontSize: 16, fontWeight: 'bold' }},
        data: data
      })
      for (const item of data.otherOrgConsumptionList) {
        graphData.push({
          name: item.orgId !== data.orgId ? item.orgId + '' : item.orgId + 'self', // item.orgName,
          displayName: item.orgName + '消耗积分\n' + item.consumption + '积分',
          value: item.consumption,
          // category: 0,
          data: item
        })
        links.push({ source: data.orgId + '', target: item.orgId !== data.orgId ? item.orgId + '' : item.orgId + 'self' })
      }
      return {
        series: [{
          type: 'graph',
          layout: 'force',
          symbol: 'circle',
          symbolSize: [200, 100],
          focusNodeAdjacency: false,
          draggable: false,
          zoom: 0.75,
          label: {
            normal: {
              show: true,
              textStyle: { fontSize: 14, color: '#333' },
              formatter: (params) => {
                return params.data.displayName
              }
            }
          },
          force: { repulsion: 9000, layoutAnimation: false },
          roam: false,
          lineStyle: { normal: { color: '#333' }},
          itemStyle: { color: '#fff', borderColor: '#000', borderWidth: 2 },
          data: graphData,
          links: links
        }]
      }
    },
    // 重绘
    resizeView() {
      for (const item of this.chartEle) {
        if (item) {
          item.resize()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .chart-container .chart-item {
    min-height: 670px;
    .chart-export {
      z-index: 20;
    }
  }
</style>
